module.exports = __webpack_public_path__ + "img/banner.196eaab2.jpg";